<template>
  <div class="filter-container">
    <FilterList
      ref="filterList"
      class="applicant-list"
      isAIRecommendedList
      hiddenMyCandidateSwitch
      :candidateList="candidateList"
      :listLoading="listLoading"
      :searchTemplate.sync="searchTemplate"
      :searchTemplateList="searchTemplateList"
      :filterGroupList="filterList"
      :actionList="actionList"
      :addBtnList="addBtnList"
      :operationList="operationList"
      :aiAnalysisActionList="aiAnalysisActionList"
      :candidateTotalCount="candidateTotalCount"
      :currentSelectedCount="currentSelectedCount"
      :jobName="jobName"
      @selectAll="handleSelectAll"
      @selectAllCard="handleSelectAllCard"
      @search="handelSearch"
      @createSearchTemplate="handleCreateSearchTemplate"
      @updateSearchTemplate="handleUpdateSearchTemplate"
      @deleteSearchTemplate="handleDeleteSearchTemplate"
      @clearSearchTemplate="handleClearSearchTemplate"
      @scrollToTop="handleScrollToTop"
    >
      <template #tableContainer>
        <TableList
          ref="tableContainer"
          :data="candidateList"
          :cancelSelectedCandidateList="cancelSelectedCandidateList"
          :operationList="operationList"
          :loading="listLoading"
          :emptyText="emptyText"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @openDetail="handleOpenDetail"
        ></TableList>
      </template>
      <template #cardContainer>
        <CardList
          ref="cardContainer"
          :data="candidateList"
          :operationList="operationList"
          :loading="listLoading"
          :emptyText="emptyText"
          @openDetail="handleOpenDetail"
        ></CardList>
      </template>
    </FilterList>

    <RecommendConditionDialog
      ref="recommendConditionDialogRef"
      :show.sync="recommendConditionDialog.show"
      :loading.sync="recommendConditionDialog.loading"
      :jobId="jobId"
      @recommend="onRecommend"
    ></RecommendConditionDialog>

    <RecommendDataLoadingDialog
      v-model="dataLoadingDialog.show"
      ref="dataLoadingDialog"
      :loading.sync="dataLoadingDialog.loading"
      :showSameConditionTip="dataLoadingDialog.showSameConditionTip"
      :taskStatus="dataLoadingDialog.taskStatus"
      @view-same="showSameConditionRecommendation"
    ></RecommendDataLoadingDialog>

    <RecommendationListDialog
      :show.sync="recommendationListDialog.show"
      :recommendationList="recommendationList"
      @view="handelViewRecommendation"
      @viewCondition="handelViewRecommendationCondition"
      @retry="handleRetryRecommend"
      @refresh="handleRefreshRecommendation"
    ></RecommendationListDialog>

    <ConfirmDialog
      :content="confirmMoveCandidateDialog.content"
      :show.sync="confirmMoveCandidateDialog.show"
      :loading="confirmMoveCandidateDialog.loading"
      :title="confirmMoveCandidateDialog.title"
      @cancel="handleCancelMoveCandidate"
      @confirm="handleConfirmMoveCandidate"
    ></ConfirmDialog>

    <InviteApplyJobDialog
      :show.sync="inviteApplyJobDialog.show"
      :loading.sync="inviteApplyJobDialog.loading"
      :job="job"
      @save="handleInviteApplyJob"
    ></InviteApplyJobDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { addI18nProperty, createI18nProperty, getConstantI18nValue, getI18nPropertyValue } from '@/i18n'
import { READ_STATUS } from '@/constant/application'
import { DEGREE } from '@/constant/meta'
import { LOAD_TASK_STATUS } from '@/constant/talentRecommendation'
import { AsyncTask } from '@/utils/common'
import FilterList from '../applicantList/filterList/layout.vue'
import CardList from '../application/talentRecommendedList/card.vue'
import TableList from './filterList/candidateList.vue'
import ConfirmDialog from '@/components/dialog/confirmDialog.vue'
import RecommendConditionDialog from './dialog/recommendConditionDialog.vue'
import RecommendDataLoadingDialog from './dialog/dataLoadingDialog.vue'
import RecommendationListDialog from './dialog/recommendationListDialog.vue'
import InviteApplyJobDialog from './dialog/inviteApplyJob.vue'

const FILTER_GROUP_TYPE = {
  RECOMMEND_INFO: 'RECOMMEND_INFO'
}

const SELECT_ALL_CANDIDATE_LIMIT = {
  ADD_TAG: 20000
}

const RECOMMENDED_STATUS = {
  MOVED: 'MOVED',
  INVITED: 'INVITED',
  PENDING: 'PENDING',
  UNQUALIFIED: 'UNQUALIFIED'
}

export default {
  components: {
    FilterList,
    TableList,
    CardList,
    RecommendConditionDialog,
    RecommendDataLoadingDialog,
    RecommendationListDialog,
    ConfirmDialog,
    InviteApplyJobDialog
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      recommendationList: [],
      currentRecommendation: null,
      currentLoadTaskId: null,

      listOrder: {
        prop: 'recommendation_rank',
        order: ''
      },
      searchTemplate: null,
      searchTemplateList: [],
      savedFilterList: [],
      candidateList: [],
      listLoading: false,
      isSelectedAllCandidate: false,
      isSelectedAllCardCandidate: false,
      selectedCandidateList: [],

      isSavingSearchTemplate: false,
      location: {
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      candidateTotalCount: 0,
      job: null,

      currentSelectedCount: 0,

      search: {},

      searchParams: null,

      cancelSelectedCandidateList: [],
      isNoRefreshSelectedCandidateList: false,

      recommendConditionDialog: {
        show: false,
        loading: false,
        filterInfo: {},
        recommendation: null
      },
      dataLoadingDialog: {
        show: false,
        loading: false,
        showSameConditionTip: false,
        taskStatus: LOAD_TASK_STATUS.PENDING
      },
      recommendationListDialog: {
        show: false
      },
      confirmMoveCandidateDialog: {
        title: '',
        content: '',
        show: false,
        loading: false,
        isAll: false,
        candidateList: []
      },
      inviteApplyJobDialog: {
        show: false,
        loading: false,
        rowData: null
      }
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount']),
    currentAccount () {
      return this.getCurrentAccount
    },
    hasCopyCandidatePermission () {
      return this.hasAnyPermission(['PREMIUM_COPY_CANDIDATE', 'PERM_HM_APPLY_JOB_FOR_CANDIDATE'])
    },
    jobId () {
      return this.$route.params.jobId
    },
    jobName () {
      if (!this.job) {
        return this.$t(`${this.i18nPrefix}.label.aiTalentRecommendedListTitle`)
      }
      return `${this.job.i18nName} - ${this.job.id} - ${this.$t(`${this.i18nPrefix}.label.aiTalentRecommendedListTitle`)}`
    },
    actionList () {
      const list = []
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.moveToApplyJob`),
          handler: this.handleMoveCandidateAction
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.talentRecommendation.inviteApplyJob`),
        handler: this.handleInviteApplyJobAction
      })
      if (this.searchParams?.status === RECOMMENDED_STATUS.PENDING) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.markRecommendedStatusToUnqualified`),
          handler: () => this.updateRecommendedStatus(RECOMMENDED_STATUS.UNQUALIFIED)
        })
      } else if (this.searchParams?.status === RECOMMENDED_STATUS.UNQUALIFIED) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.markRecommendedStatusToPending`),
          handler: () => this.updateRecommendedStatus(RECOMMENDED_STATUS.PENDING)
        })
      } else if (!this.searchParams?.status) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.markRecommendedStatusToPending`),
          handler: () => this.updateRecommendedStatus(RECOMMENDED_STATUS.PENDING)
        })
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.markRecommendedStatusToUnqualified`),
          handler: () => this.updateRecommendedStatus(RECOMMENDED_STATUS.UNQUALIFIED)
        })
      }
      return list
    },
    aiAnalysisActionList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.talentRecommendation.generateRecommendation`),
          handler: this.startCreateRecommendation
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.recommendMoreTalent`),
          handler: this.onRecommendMoreTalentBtnClick
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.viewAIRecommendationHistory`),
          handler: this.handleViewAIRecommendationHistory
        }
      ]
      return _.filter(list, (item) => !item.hidden)
    },
    addBtnList () {
      return []
    },
    operationList () {
      const list = []
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.moveToApplyJob`),
          operator: this.handleMoveCandidateOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.talentRecommendation.inviteApplyJob`),
        operator: this.handleInviteApplyJobOperation
      })
      list.push({
        hidden: (data) => data.ai_recommendation.status !== RECOMMENDED_STATUS.UNQUALIFIED,
        label: this.$t(`${this.i18nPrefix}.btn.action.markRecommendedStatusToPending`),
        operator: this.handleUpdateStatusOperation
      })
      list.push({
        hidden: (data) => data.ai_recommendation.status !== RECOMMENDED_STATUS.PENDING,
        label: this.$t(`${this.i18nPrefix}.btn.action.markRecommendedStatusToUnqualified`),
        operator: this.handleUpdateStatusOperation
      })
      return list
    },
    filterList () {
      const vm = this
      const list = [
        {
          key: FILTER_GROUP_TYPE.RECOMMEND_INFO,
          title: this.$t(`${this.i18nPrefix}.title.recommendedInfo`),
          hidden: false,
          filterList: {
            recommendation: {
              elType: 'el-cascader',
              multiple: true, // layout组件需要的值
              label: this.$t(`${this.i18nPrefix}.label.historySearch`),
              props: {
                get options () { return vm.recommendationList },
                clearable: false,
                multiple: false, // 阻止layout组件设置 multiple
                separator: ' - ',
                props: {
                  value: 'id',
                  children: 'load_task_list'
                }
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey, filterValues) => {
                  if (!value?.length) {
                    return
                  }
                  const recommendation = _.find(vm.recommendationList, { id: value[0] })
                  const loadTask = _.find(recommendation?.load_task_list, { id: value[1] })
                  if (!recommendation || !loadTask) {
                    return
                  }
                  return `${recommendation.label} - ${loadTask.label}`
                }
              },
              setParam: (params, val) => {
                params.recommendation = val?.[0]
                params.load_task = val?.[1]
              }
            },
            status: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.recommendedStatus`),
              optionValue: 'value',
              optionList: _.map(RECOMMENDED_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.label.talentRecommendation.status.${key}`)),
              setParam: (params, val) => {
                params.status = val?.value
              }
            },
            readStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.readStatus`),
              optionValue: 'value',
              optionList: _.map(READ_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.READ_STATUS.${key}`)),
              setParam: (params, val) => {
                params.is_viewed = val?.value
              }
            }
          }
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    candidateListLength () {
      return this.candidateList.length
    },
    selectAllIsIndeterminate () {
      if (this.currentSelectedCount && (this.currentSelectedCount !== this.candidateTotalCount)) {
        return true
      }
      return false
    },
    emptyText () {
      if (this.candidateListLength === 0 && this.currentRecommendation) {
        const loadTask = _.find(this.currentRecommendation.load_task_list, { id: this.currentLoadTaskId })
        if (LOAD_TASK_STATUS.isRunning(loadTask?.status)) {
          return `${this.i18nPrefix}.label.aiRecommendIsGenerating`
        } else if (LOAD_TASK_STATUS.isFailed(loadTask?.status) || LOAD_TASK_STATUS.isEmpty(loadTask?.status)) {
          return `${this.i18nPrefix}.message.recommendedIsEmptyRetryTip`
        }
      }
      return 'el.table.emptyText'
    }
  },
  created () {
    this.$eventBus.$emit('showLoading', true)
    this.pageDataLoader = this.initPageData()
  },
  mounted () {
    this.pageDataLoader.finally(() => {
      this.$eventBus.$emit('showLoading', false)
    }).then(() => {
      if (!this.recommendationList.length) {
        this.startCreateRecommendation()
        return
      }
      this.listLoading = true
      const suitableQuery = this.$route.query.suitable
      const recommendation = this.recommendationList[0]
      const key = _.findIndex(this.filterList, { key: FILTER_GROUP_TYPE.RECOMMEND_INFO })
      const search = {
        [key]: {
          recommendation: [recommendation.id, _.last(recommendation.load_task_list).id],
          suitable: suitableQuery ? suitableQuery === '1' : true
        }
      }
      return this.$refs.filterList.resetSearch({ search }, true)
    }).then((search) => {
      if (!this.recommendationList.length) {
        return
      }
      if (this.$refs.filterList) {
        this.$refs.filterList.noTriggerSearch = false
      }
      return this.handelSearch(search)
    }).finally(() => {
      this.listLoading = false
    })
  },
  methods: {
    ...mapActions('talent', ['copyTalentCandidate']),
    ...mapActions('account', [
      'getAccountPageConfigList',
      'createAccountPageConfig',
      'updateAccountPageConfig',
      'deleteAccountPageConfig'
    ]),
    ...mapActions('job', ['getJobInfo']),
    ...mapActions('talentRecommendation', [
      'getRecommendationList',
      'createRecommendation',
      'getRecommendationCreateTask',
      'getRecommendedTalentList',
      'createRecommendMoreTask',
      'createRetryRecommendTask',
      'getRecommendMoreTask',
      'updateRecommendedTalentViewed',
      'batchUpdateRecommendedTalent'
    ]),
    ...mapActions('application', ['inviteCandidateApplyJob']),
    initPageData () {
      return Promise.all([
        this.loadJobInfo(),
        this.loadSearchTemplateList(),
        this.loadRecommendationList()
      ])
    },
    async loadJobInfo () {
      // 这里应该尝试寻找其他返回值更简单的API
      const resp = await this.getJobInfo({ jobId: this.jobId })
      if (resp) {
        const job = resp.job
        addI18nProperty(job, 'i18nName', 'cn_name', 'name')
        this.job = job
      }
    },
    async loadRecommendationList () {
      const params = {
        jobId: this.jobId
      }
      const resp = await this.getRecommendationList(params)
      if (resp) {
        const vm = this
        const i18nKey = `${this.i18nPrefix}.label.historyIndex`
        const length = resp.length
        _.forEach(resp, (recommendation, index) => {
          recommendation.serial_number = length - index
          Object.defineProperty(recommendation, 'label', {
            configurable: true,
            enumerable: true,
            get () {
              return vm.$t(i18nKey, { index: recommendation.serial_number, date: moment(recommendation.created_time).format('YYYY/MM/DD') })
            }
          })
          _.forEach(recommendation.load_task_list, (task) => {
            Object.defineProperty(task, 'label', {
              configurable: true,
              enumerable: true,
              get () {
                let labelKey = 'loadTaskSerialNumberBest'
                if (this.serial_number > 1) {
                  labelKey = 'loadTaskSerialNumber'
                }
                return vm.$t(`${vm.i18nPrefix}.label.talentRecommendation.${labelKey}`, { loadTask: this.serial_number - 1 })
              }
            })
          })
        })
        this.recommendationList = resp
      }
    },
    startCreateRecommendation () {
      this.recommendConditionDialog.show = true
      this.$refs.recommendConditionDialogRef.resetCondition({ hard: this.currentRecommendation?.hard_condition, soft: this.currentRecommendation?.soft_condition })
    },
    async onRecommend (talentCondition) {
      const conditionDialog = this.recommendConditionDialog
      const loadingDialog = this.dataLoadingDialog
      conditionDialog.loading = true
      let recommendationResp = null
      let recommendation = null
      try {
        recommendationResp = await this.createRecommendation({
          job_id: this.jobId,
          talent_condition: talentCondition
        })
        if (recommendationResp) {
          if (recommendationResp.has_same_condition_recommendation) {
            loadingDialog.loading = false
            loadingDialog.showSameConditionTip = true
            loadingDialog.recommendationId = recommendationResp.same_condition_recommendation_id
          } else {
            loadingDialog.loading = true
            loadingDialog.showSameConditionTip = false
            loadingDialog.taskStatus = LOAD_TASK_STATUS.PENDING
            conditionDialog.show = false
            recommendation = recommendationResp.recommendation
          }
          loadingDialog.show = true
        }
      } catch (e) {
        this.$message({
          type: 'error',
          message: this.$t(`${this.i18nPrefix}.message.aiComparisonError`),
          duration: 5000
        })
        return
      } finally {
        conditionDialog.loading = false
      }
      if (loadingDialog.showSameConditionTip) {
        return
      }
      if (!recommendationResp) {
        this.$message({
          type: 'error',
          message: this.$t(`${this.i18nPrefix}.message.aiComparisonError`),
          duration: 5000
        })
        return
      }
      recommendation.load_task_list = []
      recommendation.serial_number = this.recommendationList.length + 1
      const vm = this
      Object.defineProperty(recommendation, 'label', {
        configurable: true,
        enumerable: true,
        get () {
          return vm.$t(`${vm.i18nPrefix}.label.historyIndex`, { index: recommendation.serial_number, date: moment(recommendation.created_time).format('YYYY/MM/DD') })
        }
      })
      this.recommendationList.splice(0, 0, recommendation)
      this.currentRecommendation = recommendation
      this.recommendMoreTalent(recommendationResp)
    },
    async onRecommendMoreTalentBtnClick () {
      this.recommendMoreTalent()
    },
    recommendMoreTalent (createdTaskResp, onFailed, onEmpty) {
      const recommendationId = this.currentRecommendation.id
      const loadingDialog = this.dataLoadingDialog
      if (!createdTaskResp) {
        loadingDialog.loading = true
        loadingDialog.showSameConditionTip = false
        loadingDialog.taskStatus = LOAD_TASK_STATUS.PENDING
        loadingDialog.show = true
      }
      this.recommendMoreTask = new AsyncTask(() => {
        return createdTaskResp || this.createRecommendMoreTask(recommendationId)
      }, (taskId) => {
        return this.getRecommendMoreTask({ recommendationId, taskId }).then(resp => {
          loadingDialog.taskStatus = resp.running_status
          if (resp.running_status === LOAD_TASK_STATUS.RANG_AND_SUMMARY_RECOMMENDED_INFO) {
            // 这时 AI 在进行评分和总结比较慢，加长获取间隔，优化性能
            this.recommendMoreTask.getterIdle = 5000
          } else {
            this.recommendMoreTask.getterIdle = 1000
          }
          return resp
        })
      }, async (taskId, resp) => {
        loadingDialog.taskStatus = resp.running_status
        loadingDialog.loading = false
        await this.$refs.dataLoadingDialog.displayEndStatus()
        loadingDialog.show = false
        const loadTask = resp.result
        if (loadTask) {
          this.currentRecommendation.has_more = loadTask.has_more
          const status = loadTask.status
          if (LOAD_TASK_STATUS.isFailed(status)) {
            this.$message({
              type: 'error',
              message: this.$t(`${this.i18nPrefix}.message.aiComparisonError`),
              duration: 5000
            })
            onFailed && onFailed()
          } else if (LOAD_TASK_STATUS.isEmpty(status)) {
            this.$message({
              type: 'warning',
              message: this.$t(`${this.i18nPrefix}.message.aiRecommendNoCandidate`),
              duration: 5000
            })
            onEmpty && onEmpty()
          } else {
            this.$message({
              type: 'success',
              message: this.$t(`${this.i18nPrefix}.message.aiRecommendSuccess`),
              duration: 5000
            })
            const loadTaskId = loadTask.id
            if (loadTaskId !== this.currentLoadTaskId) {
              const vm = this
              Object.defineProperty(loadTask, 'label', {
                configurable: true,
                enumerable: true,
                get () {
                  let labelKey = 'loadTaskSerialNumberBest'
                  if (this.serial_number > 1) {
                    labelKey = 'loadTaskSerialNumber'
                  }
                  return vm.$t(`${vm.i18nPrefix}.label.talentRecommendation.${labelKey}`, { loadTask: this.serial_number - 1 })
                }
              })
              this.currentRecommendation.load_task_list.push(loadTask)
            }
            this.refreshRecommendedCandidate(recommendationId, loadTaskId)
          }
          if (loadTask.next_async_task_id) {
            this.waitRecommendedCandidateRankingFinished(recommendationId, loadTask)
          }
        } else {
          this.$message({
            type: 'error',
            message: this.$t(`${this.i18nPrefix}.message.aiComparisonError`),
            duration: 5000
          })
        }
      }, 1000) // 这时 AI 在进行评分和总结比较慢，加长获取间隔，优化性能
    },
    waitRecommendedCandidateRankingFinished (recommendationId, loadTask) {
      this.waitFinishedTask = new AsyncTask(() => {
        return { task_id: loadTask.next_async_task_id }
      }, (taskId) => {
        return this.getRecommendMoreTask({ recommendationId, taskId })
      }, async (taskId, resp) => {
        const loadTask = resp.result
        if (loadTask.id !== this.currentLoadTaskId) {
          return
        }
        const rankingResult = loadTask.ranking_result
        _.forEach(this.candidateList, info => {
          if (info.ai_recommendation.rank) {
            return
          }
          const candidateId = info.candidate.id
          const result = rankingResult?.[candidateId]
          info.ai_recommendation.rank = result?.rank
          info.candidate.hasFit = result?.rank
          info.ai_recommendation.summary = result?.summary
          info.ai_recommendation.cn_summary = result?.cn_summary
        })
      }, 5000)
    },
    showSameConditionRecommendation () {
      const dialog = this.dataLoadingDialog
      const recommendationId = dialog.recommendationId
      dialog.show = false
      this.refreshRecommendedCandidate(recommendationId)
    },
    handelViewRecommendation (recommendationId, loadTaskId) {
      this.refreshRecommendedCandidate(recommendationId, loadTaskId)
    },
    handelViewRecommendationCondition (recommendationId, loadTaskId) {
      const recommendation = _.find(this.recommendationList, { id: recommendationId })
      this.recommendConditionDialog.show = true
      this.$refs.recommendConditionDialogRef.resetCondition({ hard: recommendation.hard_condition, soft: recommendation.soft_condition }, true)
    },
    async handleRetryRecommend (recommendationId, loadTaskId) {
      const recommendation = _.find(this.recommendationList, { id: recommendationId })
      const loadTask = _.find(recommendation.load_task_list, { id: loadTaskId })
      if (!recommendation || !loadTask || !(LOAD_TASK_STATUS.isEmpty(loadTask.status) || LOAD_TASK_STATUS.isFailed(loadTask.status))) {
        return
      }
      loadTaskId = loadTask.id
      const loadingDialog = this.dataLoadingDialog
      loadingDialog.loading = true
      loadingDialog.showSameConditionTip = false
      loadingDialog.taskStatus = LOAD_TASK_STATUS.PENDING
      loadingDialog.show = true
      this.currentRecommendation = recommendation
      this.currentLoadTaskId = loadTaskId
      // 仅重置页面上的 filter 值
      this.refreshRecommendedCandidate(recommendationId, loadTaskId, true)
      const resp = await this.createRetryRecommendTask({ recommendationId, loadTaskId })
      if (resp) {
        if (resp.has_finished) {
          // 刷新列表
          this.refreshRecommendedCandidate(recommendationId, loadTaskId)
        } else {
          this.recommendMoreTalent(resp, () => {
            this.candidateTotalCount = 0
            this.candidateList = []
          }, () => {
            this.candidateTotalCount = 0
            this.candidateList = []
          })
        }
      } else {
        this.$message({
          type: 'error',
          message: this.$t(`${this.i18nPrefix}.message.aiComparisonError`),
          duration: 5000
        })
      }
    },
    handleRefreshRecommendation (callback) {
      this.loadRecommendationList().finally(() => {
        callback && callback()
      })
    },
    refreshRecommendedCandidate (recommendationId, loadTaskId, noTriggerSearch) {
      if (this.recommendationList.length < 1) {
        return
      }

      if (!recommendationId) {
        recommendationId = this.recommendationList[0].id
      }
      const recommendation = _.find(this.recommendationList, { id: recommendationId })
      if (!loadTaskId) {
        loadTaskId = recommendation.load_task_list[0].id
      }

      const key = _.findIndex(this.filterList, { key: FILTER_GROUP_TYPE.RECOMMEND_INFO })
      const search = {
        [key]: {
          recommendation: [recommendation.id, loadTaskId]
        }
      }
      if (noTriggerSearch) {
        this.search = search
        this.searchParams = this.parseSearchToParams(search)
      }
      return this.$refs.filterList.resetSearch({ search }, noTriggerSearch)
    },
    parseSearchToParams (search) {
      const params = {
        page: 1,
        page_size: 50, // 一次 推荐的数量 刚好是 50
        order: `${this.listOrder.order === '-' ? '-' : ''}${this.listOrder.prop}`
      }
      const filterList = this.filterList
      _.forEach(search, (group, groupKey) => {
        if (groupKey === 'keywords') {
          params.keywords = group
          return
        }
        if (groupKey === 'candidateName') {
          params.candidate_name = group
          return
        }
        if (groupKey === 'candidateId') {
          params.candidate_id = _.filter(group, item => item && !isNaN(item)).join(',')
          return
        }
        const groupFilters = filterList[groupKey]
        _.forEach(group, (filterValue, filterName) => {
          const filter = groupFilters?.filterList[filterName]
          if (!filter || !filterValue) {
            return
          }
          filter.setParam(params, filterValue)
        })
      })
      return params
    },
    async handelSearch (search) {
      this.search = search
      const params = this.searchParams = this.parseSearchToParams(search)
      this.listLoading = true
      if (!params.recommendation) {
        await this.$nextTick()
        this.refreshRecommendedCandidate()
        return
      }
      this.currentRecommendation = _.find(this.recommendationList, { id: params.recommendation })
      this.currentLoadTaskId = params.load_task
      try {
        const resp = await this.getRecommendedTalentList({
          recommendationId: params.recommendation,
          params
        })
        const candidateList = []
        if (resp) {
          const vm = this
          this.candidateTotalCount = resp.total_count
          _.forEach(resp.data, talentInfo => {
            candidateList.push(talentInfo)
            talentInfo.selected = false
            createI18nProperty(talentInfo.ai_recommendation, 'statusI18nName', `${this.i18nPrefix}.label.talentRecommendation.status.${talentInfo.ai_recommendation.status}`)
            const candidate = talentInfo.candidate
            candidate.age = candidate.birthday ? moment().diff(candidate.birthday, 'year') : ''
            candidate.name = talentInfo.is_agency_uploaded_and_hid ? this.$t(`${this.i18nPrefix}.label.hidedCandidateName`) : candidate.name
            candidate.hasFit = talentInfo.ai_recommendation?.rank
            Object.defineProperty(candidate, 'maxDegreeI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const maxDegree = candidate.max_degree
                return getConstantI18nValue(DEGREE, maxDegree, 'meta.DEGREE')
              }
            })
            Object.defineProperty(candidate, 'candidateStatusName', {
              configurable: true,
              enumerable: true,
              get () {
                let i18nKey = null
                if (candidate.is_alumni) {
                  i18nKey = 'alumni'
                } else if (candidate.is_employee) {
                  i18nKey = 'employee'
                } else {
                  i18nKey = 'candidate'
                }
                if (!talentInfo.reviewed) {
                  i18nKey += 'New'
                }
                return vm.$t(`${vm.i18nPrefix}.label.${i18nKey}`)
              }
            })
            Object.defineProperty(talentInfo, 'locationI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const location = talentInfo.candidate.location
                const province = getI18nPropertyValue(location.province, 'cn_name', 'name')
                const city = getI18nPropertyValue(location.city, 'cn_name', 'name')
                return city || province
              }
            })
            Object.defineProperty(talentInfo, 'totalWorkYear', {
              configurable: true,
              enumerable: true,
              get () {
                const totalWorkYear = talentInfo.candidate.total_work_year
                if (!totalWorkYear) {
                  return ''
                }
                let totalWorkYearI18nName = ''
                if (talentInfo.job.experience_required !== 'N') {
                  if (totalWorkYear < 1) {
                    totalWorkYearI18nName = `${parseInt(totalWorkYear * 12)} ${vm.$t(`${vm.i18nPrefix}.label.month`)}`
                  } else {
                    totalWorkYearI18nName = `${Math.floor(totalWorkYear * 10) / 10} ${vm.$t(`${vm.i18nPrefix}.label.year`)}`
                  }
                }
                return totalWorkYearI18nName
              }
            })
          })
        }
        this.candidateList = candidateList
      } finally {
        this.listLoading = false
      }
    },
    handleSelectedChange (val) {
      this.selectedCandidateList = val
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      if (val.length !== this.candidateList.length) {
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.isClickSelectAll = false
      }
      if (this.isSelectedAllCandidate && this.isSelectedAllCardCandidate) {
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
      } else if (this.isSelectedAllCandidate || this.isSelectedAllCardCandidate) {
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateList.length - cancelSelectCount
      } else if (this.isClickSelectAll) {
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateTotalCount - cancelSelectCount
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
      } else {
        this.currentSelectedCount = val.length
        this.isNoRefreshSelectedCandidateList = true
      }
      const cancelCandidateIds = _.map(this.cancelSelectedCandidateList, candidate => candidate.candidate.id)
      this.searchParams.cancel_candidate_ids = cancelCandidateIds.join(',')
    },
    handleSelectAllCard (selected) {
      if (selected) {
        const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
        _.forEach(this.candidateList, candidate => {
          if (!candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          }
        })
        this.isSelectedAllCandidate = true
        this.isSelectedAllCardCandidate = true
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
        this.isClickSelectAll = true
        this.isNoRefreshSelectedCandidateList = false
      } else {
        _.forEach(this.candidateList, candidate => {
          candidate.selected = false
        })
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.currentSelectedCount = 0
        this.isClickSelectAll = false
      }
      this.cancelSelectedCandidateList = []
    },
    handleSelectAll (selected) {
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      this.isSelectedAllCandidate = selected.length > 0
      this.isClickSelectAll = selected.length > 0
      this.isNoRefreshSelectedCandidateList = !this.isSelectedAllCandidate
      this.currentSelectedCount = this.isSelectedAllCandidate ? this.candidateTotalCount - hiddenCandidateList.length : 0
      this.cancelSelectedCandidateList = []
    },
    hasSelected () {
      if (!this.isSelectedAllCandidate && this.selectedCandidateList.length < 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAtLeastCandidate`))
        return false
      }
      return true
    },
    async handleMoveCandidateAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.COPY_CANDIDATE || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.COPY_CANDIDATE)) {
        this.$message({
          type: 'warning',
          message: this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.COPY_CANDIDATE }),
          duration: 5000
        })
        return
      }
      const isSelectAll = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      this.confirmMoveCandidateDialog.candidateList = candidates
      this.confirmMoveCandidateDialog.isAll = isSelectAll
      this.confirmMoveCandidateDialog.title = this.$t(`${this.i18nPrefix}.btn.action.moveToApplyJob`)
      this.confirmMoveCandidateDialog.content = this.$t(`${this.i18nPrefix}.message.copyRecommendedCandidateContent`, { count: isSelectAll ? this.candidateTotalCount : candidates.length })
      this.confirmMoveCandidateDialog.show = true
    },
    async handleConfirmMoveCandidate () {
      this.confirmMoveCandidateDialog.loading = true
      try {
        const resp = await this.copyTalentCandidate({
          target_job_ids: [this.jobId],
          candidate_list: this.confirmMoveCandidateDialog.candidateList,
          is_all_application: this.confirmMoveCandidateDialog.isAll ? 1 : 0,
          search_params: this.searchParams,
          is_ai_recommended: true,
          recommendation_id: this.currentRecommendation.id
        })
        const statusCount = _.countBy(resp, 'status')
        if (statusCount.success && statusCount.success > 0) {
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.moveCandidateToApplication.success`),
            duration: 5000
          })
          this.handelSearch(this.search)
          this.confirmMoveCandidateDialog.show = false
        } else {
          this.$message({
            type: 'error',
            message: this.$t(`${this.i18nPrefix}.message.moveCandidateToApplication.failed`),
            duration: 5000
          })
        }
      } finally {
        this.confirmMoveCandidateDialog.loading = false
      }
    },
    handleCancelMoveCandidate () {
      this.confirmMoveCandidateDialog.show = false
    },
    async handleMoveCandidateOperation (rowData) {
      this.confirmMoveCandidateDialog.candidateList = [rowData.candidate.id]
      this.confirmMoveCandidateDialog.isAllApplication = false
      this.confirmMoveCandidateDialog.title = this.$t(`${this.i18nPrefix}.btn.action.moveToApplyJob`)
      this.confirmMoveCandidateDialog.content = this.$t(`${this.i18nPrefix}.message.copyOneCandidateRecommendedCandidateContent`, { count: 1 })
      this.confirmMoveCandidateDialog.show = true
    },
    handleViewAIRecommendationHistory () {
      this.recommendationListDialog.show = true
    },
    handleUpdateStatusOperation (rowData) {
      const status = rowData.ai_recommendation.status
      let targetStatus = null
      if (status === RECOMMENDED_STATUS.UNQUALIFIED) {
        targetStatus = RECOMMENDED_STATUS.PENDING
      } else if (status === RECOMMENDED_STATUS.PENDING) {
        targetStatus = RECOMMENDED_STATUS.UNQUALIFIED
      } else {
        return
      }
      this.updateRecommendedStatus(targetStatus, rowData)
    },
    async updateRecommendedStatus (status, rowData) {
      this.listLoading = true
      try {
        if (!rowData) {
          const hasSelected = this.hasSelected()
          if (!hasSelected) {
            return
          }
        }
        const isSelectAll = rowData ? false : (this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate))
        const candidateIds = rowData ? [rowData.candidate.id] : _.map(this.selectedCandidateList, 'candidate.id')
        const resp = await this.batchUpdateRecommendedTalent({
          recommendationId: this.currentRecommendation.id,
          data: {
            search_params: this.searchParams,
            is_all: isSelectAll,
            candidate_list: candidateIds,
            status: status
          }
        })
        if (resp) {
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.updateRecommendedCandidateSuccess`),
            duration: 5000
          })
          await this.handelSearch(this.search)
        }
      } finally {
        this.listLoading = false
      }
    },
    handleViewAIRecommended (history) {
      const key = _.findIndex(this.filterList, { key: FILTER_GROUP_TYPE.RECOMMEND_INFO })
      const search = {
        [key]: {
          history: `${history}`
        }
      }
      this.$refs.filterList.resetSearch({ search })
    },
    async handleInviteApplyJobAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const dialog = this.inviteApplyJobDialog
      dialog.rowData = null
      dialog.show = true
    },
    async handleInviteApplyJobOperation (rowData) {
      const dialog = this.inviteApplyJobDialog
      dialog.rowData = rowData
      dialog.show = true
    },
    async handleInviteApplyJob (invitation) {
      const dialog = this.inviteApplyJobDialog
      dialog.loading = true
      try {
        if (!dialog.rowData) {
          const hasSelected = this.hasSelected()
          if (!hasSelected) {
            return
          }
        }
        const isSelectAll = dialog.rowData ? false : (this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate))
        const candidateIds = dialog.rowData ? [dialog.rowData.candidate.id] : _.map(this.selectedCandidateList, 'candidate.id')
        const resp = await this.inviteCandidateApplyJob({
          current_job_id: this.jobId,
          candidate_ids: candidateIds,
          job_ids: [this.jobId],
          subject: invitation.subject,
          content: invitation.content,
          is_ai_recommended: true,
          is_all: isSelectAll,
          search_params: this.searchParams,
          recommendation_id: this.currentRecommendation.id
        })
        if (resp) {
          if (resp.success && resp.success.length > 0) {
            this.$message.success(this.$t('admin.application.invitation.applyJob.message.inviteSuccess'))
            this.handelSearch(this.search)
            dialog.show = false
          } else if (resp.no_email_count && resp.no_email_count.length > 0) {
            this.$message.warning(this.$t('admin.application.invitation.applyJob.message.inviteNoEmailAccount'))
          } else if (resp.over_times_count && resp.over_times_count.length > 0) {
            this.$message.error(this.$t('admin.application.invitation.applyJob}.message.inviteOverLimitTimes'))
          } else {
            this.$message.error(this.$t('admin.application.invitation.applyJob.message.inviteFail'))
          }
        } else {
          this.$message.error(this.$t('admin.application.invitation.applyJob.message.inviteFail'))
        }
      } finally {
        dialog.loading = false
      }
    },
    async loadSearchTemplateList () {
      const resp = await this.getAccountPageConfigList({ page_type: 'TALENT_RECOMMENDED_LIST' })
      if (resp) {
        this.searchTemplateList = _.map(resp, pageConfig => {
          return {
            _config: pageConfig,
            id: pageConfig.id,
            name: pageConfig.config.name,
            search: pageConfig.config.search
          }
        })
      }
    },
    async handleCreateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createAccountPageConfig({
          page_type: 'TALENT_RECOMMENDED_LIST',
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleUpdateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateAccountPageConfig({
          id: template._config.id,
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleClearSearchTemplate () {
      this.searchTemplate = null
    },
    async handleDeleteSearchTemplate (searchTemplate, deletedTemplateIndex) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAccountPageConfig({
          id: searchTemplate.id
        })
        if (resp) {
          this.searchTemplateList.splice(deletedTemplateIndex, 1)
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleOpenDetail (rowData) {
      const candidateId = rowData.candidate.id
      rowData.reviewed = true
      this.updateRecommendedTalentViewed({
        recommendationId: this.currentRecommendation.id,
        candidateId: candidateId
      })
      const params = encodeURIComponent(JSON.stringify(this.parseSearchToParams(this.search)))
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/talent-pool/candidate/profile?candidate_id=${candidateId}&is_recommended=1&list_params=${params}&back=${backUrl}`)
    },
    handleScrollToTop (listType) {
      this.$nextTick(() => {
        const candidateListRef = listType === 'table' ? this.$refs.tableContainer : this.$refs.cardContainer
        candidateListRef.scrollToTop && candidateListRef.scrollToTop()
      })
    }
  },
  watch: {
    candidateListLength () {
      if (this.isNoRefreshSelectedCandidateList) {
        return
      }
      if (this.$refs.tableContainer && (this.isSelectedAllCandidate || this.selectAllIsIndeterminate)) {
        this.$refs.tableContainer.refreshSelectAllCandidate()
      }
      if (this.$refs.cardContainer && (this.isSelectedAllCardCandidate || this.selectAllIsIndeterminate)) {
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(this.cancelSelectedCandidateList, candidate) && !candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          } else {
            candidate.selected = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  width: 100%;
  height: 100%;
}
</style>
